<template>

  <div class="c-text-column c-text-left c-font-16"
    style="left: 10%;right: 10%;width: 80%;position: relative;line-height: 1.5;">
    <div class="c-text-between c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span style="color: #587380;font-size: 12px;">手册与补充支持材料</span>
        <h1>产品文档</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          探索 Franka Robotics 产品的全面文档，包括产品手册、数据表、证书及安装指南。
        </span>
      </div>
      <div class="display-width">
        <img src="@/assets/images/applications/20220920_Franka_Research1771.jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    <h3 style="font-size: 28px;">Franka Research 3</h3>
    <div>注：所有Franka Research 3文档同样适用于Franka Production 3</div>

    <li class="c-mt-20">软硬件兼容性矩阵
      <span class="linkTag">
        <a href="https://franka.de/FR3-compatibility-matrix" target="_blank">[英文]</a>
      </span>
    </li>
    <li class="c-mt-20">系统镜像更新日志
      <span class="linkTag">
        <a href="https://download.franka.de/Franka_Robotics_Update_History.pdf" target="_blank">[英文]</a>
      </span>
    </li>
    <li class="c-mt-20">Franka Research 3 硬件手册 (文档编号: R02210)
    </li>
    <div>这些文档包含硬件相关信息，并关联以下机械臂版本：</div>
    <div style="line-height: 1.5;">
      -FR3 Arm v2.1
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.2_EN.pdf?hsLang=en" rel="noopener" target="_blank">[英文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_DE.pdf?hsLang=en" rel="noopener" target="_blank">[德文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_ZH-Hans.pdf?hsLang=en" rel="noopener" target="_blank">[中文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_%20CS.pdf?hsLang=en" rel="noopener" target="_blank">[捷克文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_DA.pdf?hsLang=en" rel="noopener" target="_blank">[丹麦文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_ES.pdf?hsLang=en" rel="noopener" target="_blank">[西班牙文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_FR.pdf?hsLang=en" rel="noopener" target="_blank">[法文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_IT.pdf?hsLang=en" rel="noopener" target="_blank">[意大利文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.1_R02210_1.0_KO.pdf?hsLang=en" rel="noopener" target="_blank">[韩文]</a>
    </div>
    <div style="line-height: 1.5;">
      -FR3 Arm v2.0
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm%20v2.0_R02210_1.2_EN.pdf?hsLang=en" rel="noopener" target="_blank">[英文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_DE.pdf?hsLang=en" rel="noopener" target="_blank">[德文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_ZH.pdf?hsLang=en" rel="noopener" target="_blank">[中文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_CS.pdf?hsLang=en" rel="noopener" target="_blank">[捷克文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_DA.pdf?hsLang=en" rel="noopener" target="_blank">[丹麦文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_ES.pdf?hsLang=en" rel="noopener" target="_blank">[西班牙文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_FR.pdf?hsLang=en" rel="noopener" target="_blank">[法文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_IT.pdf?hsLang=en" rel="noopener" target="_blank">[意大利文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_JA.pdf?hsLang=en" rel="noopener" target="_blank">[日文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_KO.pdf?hsLang=en" rel="noopener" target="_blank">[韩文]</a>
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Armv2.0_R02210_1.0_PL.pdf?hsLang=en" rel="noopener" target="_blank">[波兰文]</a>
    </div>
    <div style="line-height: 1.5;">
      -FR3 Arm v1
      <a class="linkTag" href="https://franka.de/hubfs/Hardware%20Manual%20Franka%20Research%203_Arm_v1_R02210_1.2_EN.pdf?hsLang=en" rel="noopener" target="_blank">[英文]</a>
     </div>
     
    <li class="c-mt-20">Franka Research 3 操作手册 (文档编号: R02216)
    </li>
    <div>这些文档包含系统操作详细信息，并关联以下系统镜像版本：</div>
    <div>-系统镜像 v5.10
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Operating%20Manual%20Franka%20Research%203_5.10_R02216_1.3_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.9
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Operating%20Manual%20Franka%20Research%203_5.9_R02216_1.2.2_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.8
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Operating%20Manual%20Franka%20Research%203_System_Image_5.8_R02216_1.1.1_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.6.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Operating%20Manual%20Franka%20Research%203_System_Image_5.6.0_R02216_1.0.1_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <li class="c-mt-20">Franka Research 3 产品手册（文档编号：R02210）</li>
    <div>本手册专为 FR3 机械臂 v1 版本发布，将硬件规格详情与操作说明整合于单一文件之中。</div>
    <div>-系统镜像 v5.8.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.5.2_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.5_DE.pdf?hsLang=en"
          target="_blank">[德文]</a>
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.5_CS.pdf?hsLang=en"
          target="_blank">[捷克文]</a>
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.5_ZH.pdf?hsLang=en"
          target="_blank">[中文]</a>
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.5_IT.pdf?hsLang=en"
          target="_blank">[意大利文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.7.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.4_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.6.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.3_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.5.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.2_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.4.0
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/Product%20Manual%20Franka%20Research%203_R02210_1.1_EN.pdf"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/Product%20Manual%20Franka%20Research%203_R02210_1.1_DE.pdf"
          target="_blank">[德文]</a>
      </span>
    </div>
    <div>-系统镜像 v5.3.1
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.0_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Research%203_R02210_1.0_DE.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </div>
    <li class="c-mt-40">Franka Research 3 数据手册（文档编号：R02212）</li>
    <div>-FR3 Arm v2.1, v2.2
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_2.6_EN_July%202026.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_2.6_DE_Juli%202026.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </div>
    <div>-FR3 Arm v2.0
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_2.2.2_EN_June%202026.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_2.2.2_DE_Juni%202026.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </div>
    <div>-FR3 Arm v1
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_1.4_EN_June%202026.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Datasheet%20Franka%20Research%203_R02212_1.4_DE_June%202026.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </div>
    <li class="c-mt-40">静电放电(ESD)测量报告</li>
    <div>-FR3 Arm v2（文件编号: R05015）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/ESD%20Measurements%20Franka%20Research%203_R05015_2.0_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-FR3 Arm v1（文件编号: R02012）
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/ESD%20Datasheet_R02012_1.0_EN.pdf" target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/ESD%20Datasheet_R02012_1.0_DE.pdf" target="_blank">[德文]</a>
      </span>
    </div>
    <li class="c-mt-40">Franka Research 3 包装说明
      <span class="linkTag">
        <a href="https://franka.de/hubfs/Packaging%20Instructions%20Franka%20Research%203_R02041_1.0_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://franka.de/hubfs/Packaging%20Instructions%20Franka%20Research%203_R02041_1.0_DE.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </li>
    <li>Franka Research 3 快速安装指南
      <span class="linkTag">
        <a href="https://download.franka.de/documents/Quick%20Guide%20for%20Installation%20Franka%20Production-Research%203_R02040_1.1_ML.pdf"
          target="_blank">[多语言]</a>
      </span>
    </li>
    <li>FR3 状态指示灯颜色代码
      <span class="linkTag">
        <a href="https://download.franka.de/documents/FX3%20Color%20code%20of%20status%20light_R02045_ML.pdf"
          target="_blank">[多语言]</a>
      </span>
    </li>
    <li>钻孔模板
      <span class="linkTag">
        <a href="https://download.franka.de/documents/Drilling%20template_R02042_1.0.pdf" target="_blank">[工程图纸]</a>
      </span>
    </li>
    <li>FR3 RoHS-REACH 信息页
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/RoHS-REACH-Infosheet_FX3_R02013_1.0_EN.pdf"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/RoHS-REACH-Infosheet_FX3_R02013_1.0_DE.pdf"
          target="_blank">[德文]</a>
      </span>
    </li>
    <li>FR3 中国RoHS2 信息页
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/China-RoHS2-Infosheet_R02014_1.0_EN.pdf" target="_blank">[英文]</a>
      </span>
    </li>
    <li class="c-mt-40">证书</li>
    <div>适用于 FR3 机械臂 v2、控制器 v1、系统镜像 5.8 及此前版本</div>
    <div>-EN ISO 13849-1:2015 认证证书（3类，性能等级d）
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/110901_Certificate%20EN%20ISO%2013849%2012015_1.0_EN.pdf"
          target="_blank">[英文]</a>
      </span>
    </div>
    <div>-EN ISO 10218-1:2011 认证证书
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/110900_Certificate%20EN%20ISO%2010218%2012011_1.1_EN.pdf" target="_blank">[英文]</a>
      </span>
    </div>
    <li class="c-mt-40">证书扩展</li>
    <div>-EN ISO 13849-1:2023 认证证书（3类，性能等级d）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Z10%20117181%200001%20Rev.%2003.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </div>
    <h3 style="font-size: 28px;margin-top: 35px;">Franka Research 3 双机系统（FR3 Duo）</h3>
    <li>FR3 Duo 快速安装指南（文档编号：R04240）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Quick%20Installation%20Guide%20FR3%20Duo_R04240_1.3_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <h3 style="font-size: 28px;margin-top: 35px;">移动式 FR3 双机系统（Mobile FR3 Duo）</h3>
    <li>移动式 FR3 Duo 快速安装指南（文档编号：R05240）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Quick%20Guide%20for%20Installation%20Mobile%20FR3%20Duo_R05240_1.0_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <li>移动式 FR3 Duo 原型手册与数据手册（文档编号：R04245）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Prototype%20Manual%20and%20Datasheets%20_Mobile%20FR3%20Duo_R04245_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <div id="franka-hand"></div>
    <h3 style="font-size: 28px;margin-top: 35px;">Franka Hand</h3>
    <li>产品手册 Franka Hand（文档编号：R50010）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Hand_R50010_1.2_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20Franka%20Hand_R50010_1.2_DE.pdf?hsLang=en"
          target="_blank">[德文]</a>
      </span>
    </li>
    <li>Franka Hand安装快速指南
      <span class="linkTag">
        <a href="https://download.franka.de/documents/Quick%20Connecting%20Guide%20Franka%20Hand_R50040_1.1_ML.pdf"
          target="_blank">[英文,德文,中文]</a>
      </span>
    </li>
    
    <h3 style="font-size: 28px;margin-top: 35px;">Franka GELLO（单臂）/ Franka GELLO Duo（双臂）</h3>
    <li>Franka GELLO v0.1 快速安装指南（文档编号：R61040）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Quick%20Guide%20for%20Installation%20Franka%20GELLO_0.1_R61040_1.0_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <li>Franka GELLO Duo v0.5 快速安装指南（文档编号：R62040）
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Quick%20Guide%20for%20Installation%20Franka%20GELLO%20DUO_0.5_R62040_1.2_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <li>开源代码 
      <span class="linkTag c-mr-5">
        <a href="https://github.com/wuphilipp/gello_software/tree/main/ros2"
          target="_blank">[英文]</a>
      </span>
    </li>
    <li>开源 3D 文件
      <span class="linkTag c-mr-5">
        <a href="https://github.com/wuphilipp/gello_mechanical/tree/main/franka_fr3"
          target="_blank">[英文]</a>
      </span>
    </li>

    <h3 style="font-size: 28px;margin-top: 35px;">Cobot Pump</h3>
    <li>操作说明 ECBPi CobotPump
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/221010_Operating%20Instructions%20ECBPi%20CobotPump_11.18_EN.pdf"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/221010_Operating%20Instructions%20ECBPi%20CobotPump_11.18_DE.pdf"
          target="_blank">[德文]</a></span>
    </li>
    <h3 style="font-size: 28px;margin-top: 35px;">Service Box（已停产）</h3>
    <li>Service Box 快速指南
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/Quick%20Guide%20Service%20Box_R81040_1.0_EN.pdf"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/Quick%20Guide%20Service%20Box_R81040_1.0_DE.pdf"
          target="_blank">[德文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/Quick%20Guide%20Service%20Box_R81040_1.0_ZH.pdf"
          target="_blank">[中文]</a>
      </span>
    </li>
    <h3 style="font-size: 28px;margin-top: 35px;">Franka AI Companion（已停产）</h3>
    <li>Franka AI Companion 产品手册
      <span class="linkTag c-mr-5">
        <a href="https://franka.de/hubfs/Product%20Manual%20AI%20Companion_R82010_1.1_EN.pdf?hsLang=en"
          target="_blank">[英文]</a>
      </span>
    </li>
    <h3 style="font-size: 28px;margin-top: 35px;">Franka Emika机器人(已停产)</h3>
    <li>Franka Emika 机器人产品手册
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/documents/100010_Product%20Manual%20Franka%20Emika%20Robot_10.21_EN.pdf"
          target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/100010_Product%20Manual%20Franka%20Emika%20Robot_10.21_DE.pdf"
          target="_blank">[德文]</a></span>
      <span class="linkTag">
        <a href="https://download.franka.de/documents/100010_Product%20Manual%20Franka%20Emika%20Robot_10.21_ZH.pdf"
          target="_blank">[中文]</a></span>
    </li>
    <li>Franka Emika 机器人生命周期终止通知
      <span class="linkTag c-mr-5">
        <a href="https://download.franka.de/End-of-Life-Franka-Emika-Robot_EN.pdf" target="_blank">[英文]</a>
      </span>
      <span class="linkTag">
        <a href="https://download.franka.de/End-of-Life-Franka-Emika-Robot.pdf" target="_blank">[德文]</a></span>
    </li>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {

    }
  },
  methods: {
    // 跳转到指定页码
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    }
  }
}
</script>

<style scoped>
.linkTag{
  margin: 0 2px;
}
.buttonContro {
  background-color: white;
  border: 2px solid #b0c1d400;
  cursor: pointer;
  font-size: 16px;

}

.buttonContro:hover {
  color: #0b7bb3;

}

.buttonPage {
  background-color: white;
  border: 2px solid #b0c1d400;
  cursor: pointer;
  line-height: 1;
  margin: 0 0.1rem;
  padding: 0.25rem 0.4rem;
  text-decoration: none;
  border-radius: 7px;
  font-size: 16px;
}

.buttonPage:hover {
  border: 2px solid #b0c1d4;

}

button.active {
  font-weight: bold;
  border: 2px solid #b0c1d4;
  border-radius: 7px;
}

button:disabled {
  color: #ccc;
}

.content {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 限制为2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* 隐藏超出的内容 */
  text-overflow: ellipsis;
  /* 添加省略号 */
  font-size: 14px;
  /* 默认字体大小 */
}

.display-width {
  width: calc(50% - 40px);
}

.newContent {
  width: 500px;
  padding: 16px;
  box-shadow: -5px 0px 20px 0px rgb(73 75 77 / 10%);
  margin: 20px;

}

.newImg {
  height: 300px;
}

@media (max-width: 1029px) {
  .newContent {
    width: 100%;

  }

  .newImg {
    height: 100%;
  }
}

@media (max-width: 899px) {
  .display-width {
    width: 100%
  }

}

.c-title-document {
  margin-top: -90px;
  background-image: url(../assets/images/news/documentBg.jpg) !important;
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  height: 500px;
  width: 100vw;
}

.background-layers {
  background-image: url(../assets/images/news/news2.jpg) !important;
  background-size: 100% 100%;
  /* aspect-ratio: 468 / 294; */
  /* background-position: center bottom !important;
    background-size: cover !important;
    background-repeat: no-repeat !important; */
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}
</style>
